'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var certificates = exports.certificates = {
  title: 'Certifica tu formación',
  background_url: 'https://dev-res.thumbr.io/images/certificates-banner.jpg',
  description: 'Mejora tu formación y CV con certificados personales e intransferibles',
  find_courses: 'Encuentra cursos',
  how_it_works_title: 'Cómo funciona',
  features: JSON.stringify(['learn', 'download', 'verify']),
  learn_icon: 'https://lib.tutellus.com/images/icons/add-to-cart.svg',
  learn_title: 'Apúntate a cualquier curso',
  learn_description: 'Los certificados están disponibles en cualquier curso. Debes superar el 90% para optar a él.',
  download_icon: 'https://lib.tutellus.com/images/icons/download.svg',
  download_title: 'Descarga el Certificado',
  download_description: 'Será visible desde cualquier dispositivo y lo podrás descargar en PDF tantas veces como quieras.',
  verify_icon: 'https://lib.tutellus.com/images/icons/certificate.svg',
  verify_title: 'Muestra tus capacidades',
  verify_description: 'Cada Certificado dispone de un código único para demostrar su veracidad, personal e intransferible.',
  validation_title: 'Validación única e intrasferible con tecnología securizada',
  validation_description: 'Generamos un conjunto de algoritmos en el momento de la emisión del Certificado que hacen que su validez sea única y solo tuya, irrepicable e incopiable.',
  validation_features: JSON.stringify(['url', 'qr', 'everywhere']),
  url_validation_title: 'Validación por URL',
  url_validation_description: 'Muestra en Linkedin la url de validación el certificado. Es pública.',
  url_validation_image: 'https://dev-res.thumbr.io/images/api-segmentation.png',
  qr_validation_title: 'Validación por QR',
  qr_validation_description: 'Utiliza donde quieras el código generado. Es intrasferible e incopiable.',
  qr_validation_image: 'https://dev-res.thumbr.io/images/api-bigdata.png',
  everywhere_validation_title: 'En cualquier soporte',
  everywhere_validation_description: 'La url y el código QR los podrás añadir en documentos, mails o donde quieras.',
  everywhere_validation_image: 'https://dev-res.thumbr.io/images/api-earn.png',
  how_it_looks_title: 'Así serán tus Certificados',
  how_it_looks_image: 'https://dev-res.thumbr.io/images/certificates-ipad-view.png',
  register: 'Regístrate'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/certificates.js
// module id = 695
// module chunks = 0